import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { FiPhone } from 'react-icons/fi';
import { HiOutlineMail } from 'react-icons/hi';
import { GiBackwardTime } from 'react-icons/gi';
import { Avatar, AvatarFallback, AvatarImage } from '@components/common/Avataar';
import { Badge } from '@components/common/Badge';
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from '@components/common/Drawer';

const CandidateDrawer = ({ isOpen, onOpenChange, candidate }) => {
    return (
        <Drawer open={isOpen} onOpenChange={onOpenChange}>
            <DrawerContent className="w-[400px] right-0 left-auto h-full rounded-l-lg">
                <DrawerHeader>
                    <DrawerTitle>View Candidate:</DrawerTitle>
                    <div className="mt-6 flex items-start gap-4">
                        <Avatar className="h-12 w-12">
                            <AvatarImage src={'//'} />
                            <AvatarFallback>
                                {(candidate?.candidate_name || '').charAt(0)}
                            </AvatarFallback>
                        </Avatar>
                        <div className="space-y-3 flex-1">
                            <h2 className="text-xl font-semibold">
                                {candidate?.candidate_name || ''}
                            </h2>
                            <div className="space-y-2 text-sm">
                                <div className="flex items-center gap-2">
                                    <FiPhone className="text-primary-blue" />
                                    <span>{candidate.candidate_mob_no}</span>
                                </div>
                                <div className="flex items-center gap-2">
                                    <HiOutlineMail className="text-primary-blue" />
                                    <span>{candidate.email || 'N/A'}</span>
                                </div>
                                <div className="flex items-center gap-2">
                                    <GiBackwardTime className="text-primary-blue" />
                                    <span>
                                        {candidate.lastUpdated
                                            ? format(
                                                  new Date(candidate.lastUpdated),
                                                  'dd MMM yyyy HH:mm',
                                              )
                                            : 'N/A'}
                                    </span>
                                </div>
                            </div>
                            <Badge
                                variant={
                                    candidate.status === 'Rejected'
                                        ? 'danger'
                                        : candidate.status === 'Accepted'
                                        ? 'success'
                                        : candidate.status === 'Review'
                                        ? 'default'
                                        : 'warning'
                                }
                                className="rounded-full"
                            >
                                {candidate.status}
                            </Badge>
                        </div>
                    </div>
                </DrawerHeader>
            </DrawerContent>
        </Drawer>
    );
};

CandidateDrawer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onOpenChange: PropTypes.func.isRequired,
    candidate: PropTypes.shape({
        candidate_name: PropTypes.string.isRequired,
        candidate_mob_no: PropTypes.string,
        email: PropTypes.string,
        lastUpdated: PropTypes.string,
        status: PropTypes.oneOf(['Pending', 'Review', 'Rejected', 'Accepted']),
    }).isRequired,
};

export default CandidateDrawer;
